declare const scopeBrand: unique symbol;

/**
 * Opaque type of a scope for `useLastSuccessfulData`. A plain string, even a
 * string literal, does not satisfy it. Only the values of
 * `LAST_SUCCESSFUL_DATA_SCOPES` do.
 */
export type LastSuccessfulDataScope = string & { readonly [scopeBrand]: true };

/**
 * Each value must equal its own key. Object keys are unique (TS1117 on a
 * repeated key), so values are unique too. A value that differs from its key
 * fails to compile.
 */
export const defineLastSuccessfulDataScopes = <
  const T extends Record<string, string>,
>(
  scopes: T & { readonly [K in keyof T]: K },
) => scopes as unknown as { readonly [K in keyof T]: LastSuccessfulDataScope };

/**
 * One entry per data source. A legacy table and its v3 twin read the same
 * query, so they share an entry on purpose.
 */
export const LAST_SUCCESSFUL_DATA_SCOPES = defineLastSuccessfulDataScopes({
  ACTIVITY_STATEMENTS: 'ACTIVITY_STATEMENTS',
  MARKETING_AGREEMENTS: 'MARKETING_AGREEMENTS',
  SALES_REPORT: 'SALES_REPORT',
});
